module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Wuerttemberg--148a6736101b99b9a85fa217ce4482ad.jpeg";